import base from '../modules/base/default-config.json'

const defaultConfigs = {
    'base': base
}

/**
 * @typedef {Object} Config
 * @property {Object?} styles
 *
 * @typedef {Object} Module
 * @property {string} name
 * @property {Config} configJSON
 * @property {srcs: { name?: string, content?: string }?}[];
 */
export class ModuleRepository {
    /**
     * @constructor
     * @param {Module[]} modules
     */
    constructor(modules) {
        this.modules = modules
    }

    /**
     * Finds a module by its name.
     * @param {string} name
     * @returns {Module|null}
     */
    findByName(name) {
        return this.modules.find(m => m.name === name) || null
    }

    /**
     * @param name
     * @returns {Object | undefined}
     */
    getConfig(name) {
        const module = this.findByName(name)
        if(module) {
            if(module.configJSON && module.configJSON !== "{}") {
                return JSON.parse(module.configJSON);
            } else {
                return defaultConfigs[name] || {}
            }
        }
        return {}
    }

    /**
     * @param name
     * @returns {Object | undefined}
     */
    getStyles(name) {
        return this.getConfig(name)?.styles
    }
}
